export const GET_SNAPCHAT = "GET_SNAPCHAT";
export const GET_SNAPCHAT_SUCCESS = "GET_SNAPCHAT_SUCCESS";
export const GET_SNAPCHAT_FAIL = "GET_SNAPCHAT_FAIL";

export const ADD_SNAPCHAT_SUCCESS = "ADD_SNAPCHAT_SUCCESS";
export const ADD_SNAPCHAT_FAIL = "ADD_SNAPCHAT_FAIL";
export const UPDATE_SNAPCHAT_SUCCESS = "UPDATE_SNAPCHAT_SUCCESS";
export const DELETE_SNAPCHAT_SUCCESS = "DELETE_SNAPCHAT_SUCCESS";
